import { PublicationRow } from '@/components/styles'
import cn from 'classnames'
import styles from '../../../publications/publications.module.scss'
import { SubaruPublicationTypeIcon } from '../customIcon'
import { ActionButton } from '@/components/styles'
import { useRouter } from 'next/router'
import useTranslation from '@/hooks/useTranslation'
import { generalHelpers } from '@tweddle-se-team/common/helpers'
import DownloadButton from '@/components/shared/downloadButton'
import SaveToLocalCheckbox from '@/components/shared/saveToLocalCheckbox'
import { useSelector } from 'react-redux'
import { configSelectors } from '@/store/configs'
import { customerHelper } from '@tweddle-se-team/common/constants'
import DirectionalArrow from '@/components/themes/common/icons/directionalArrow'

const { renamePubType } = generalHelpers
const { CUSTOMER_IDS } = customerHelper

const showBrowseIconByCustomer = {
  [CUSTOMER_IDS.SUBARU]: () => false,
  [CUSTOMER_IDS.NORDICS]: () => true
}

const DesktopPublicationRow = ({ item, publicationTypes, user, isInFrame, publicationRowClassName }) => {
  const {
    publicationType,
    contents: { ditaId, highres, webview }
  } = item
  const t = useTranslation()
  const router = useRouter()
  const customerId = useSelector(configSelectors.selectCustomerId)
  const hasWebViewOrPDF = highres || webview
  const publicationLabel = t(publicationType, renamePubType(publicationTypes, publicationType, 'label'))
  const showBrowseIcon = (showBrowseIconByCustomer[customerId] || showBrowseIconByCustomer[CUSTOMER_IDS.SUBARU])()
  return (
    <PublicationRow className={cn(styles.publicationRow, publicationRowClassName)} key={item._id}>
      <div>
        <span className={styles.iconLabelRow}>
          <SubaruPublicationTypeIcon
            name={publicationTypes?.[publicationType]?.icon || 'vehicleOwnerManual'}
            size={20}
            className={styles.headerIcon}
            aria-hidden="true"
          />
          <span className={styles.labelText}>{publicationLabel}</span>
        </span>
        {!isInFrame && <SaveToLocalCheckbox publication={item} />}
      </div>
      <div className={styles.actionButtons}>
        {hasWebViewOrPDF && (
          <DownloadButton
            publication={item}
            user={user}
            withMarginLeft={false}
            aria-label={t('download_publication', `Download ${publicationLabel} PDF`)}
          />
        )}
        {ditaId && (
          <ActionButton
            $withIcon={showBrowseIcon}
            onClick={() => router.push({ pathname: '/content', query: { id: ditaId, publicationType } })}
            appearance="primary"
            aria-label={t('browse_publication', `Browse ${publicationLabel}`)}
          >
            {t('browse')} {showBrowseIcon && <DirectionalArrow size={16} className="fix-btn-icon" />}
          </ActionButton>
        )}
      </div>
    </PublicationRow>
  )
}

export default DesktopPublicationRow
